<template>
    <PropertySearchMapLoader
        :mapConfig="mapConfig"
        apiKey="AIzaSyDK7-uqiUaMfF0i_N3fuMMXDWh5qsA-fME"
        @google-map-idle="$emit('map-idle', $event)"
        @google-map-bounds-changed="$emit('bounds-change', $event)"
        @google-map-drag-start="onDragStart"
        @google-map-drag-end="onDragEnd"
    >
        <template slot-scope="{ google, map }">

            <PropertySearchMarkers
                :app-name="'property-search-app'"
                :properties="markers"
                :google="google"
                :map="map"
                :zoomLevel="map.zoom"
                :search-type="searchType"
                @marker-mouse-over="$emit('marker-mouse-over', $event)"
                @marker-mouse-out="$emit('marker-mouse-out', $event)"
                @marker-click="$emit('marker-click', $event)"
                @marker-touchend="$emit('marker-touchend', $event)"
                :highlighted-property="highlightedProperty"
            />
            <!-- <GoogleMapLine
                    v-for="line in lines"
                    :key="line.id"
                    :path.sync="line.path"
                    :google="google"
                    :map="map"
                  /> -->
            <GoogleMapInfoWindow
                :google="google"
                :map="map"
                :position="{
          lat: parseFloat(highlightedProperty.lat),
          lng: parseFloat(highlightedProperty.lng)
        }"
                :zoomLevel="map.zoom"
            >
                <a
                    :href="highlightedPropertyUrl"
                    class="rwps__info-window"
                    target="_blank"
                >
                    <img
                        v-if="searchType === 'for-sale' && [highlightedProperty.mls]"
                        class="rwps__info-window__mls-logo"
                        :src="searchType === 'for-sale' && mls_photos[highlightedProperty.mls] && mls_photos[highlightedProperty.mls].idx_logo_small"
                        width="56px"
                        height="18px"
                        alt="MLS Logo"
                    />
                    <div class="rwps__info-window__thumbnail-wrapper">
                        <!-- Must be an image.. background image created problems with the slot -->
                        <img
                            :src="highlightedPropertyThumbUrl"
                            alt=""
                            class="rwps__info-window__thumbnail"
                        />
                    </div>
                    <div class="rwps__info-window__content">
                        <p class="rwps__info-window__meta-text">
                            {{ parseFloat(highlightedProperty.beds) }} beds
                        </p>
                        <p class="rwps__info-window__meta-text">
                            {{ parseFloat(highlightedProperty.baths) }} baths
                        </p>
                        <p class="rwps__info-window__meta-text mb-0">
                            {{ highlightedProperty.asking_price | noChange }}
                            <template v-if="highlightedProperty.is_residential_lease">
                                /mo.</template
                            >
                        </p>
                        <p v-if="searchType === 'for-sale' && mls_photos[highlightedProperty.mls]" class="rwps__info-window__mls-text">
                            MLS ID: #{{ mls_photos[highlightedProperty.mls].mls_id }}
                        </p>
                        <!-- <a
                                        href="#"
                                        class="rwps__info-window__cart-icon"
                                        @click.prevent="$emit('add-to-cart', parseFloat(highlightedProperty.id))"
                                        aria-label="Add This Property to Your Shopping Cart">
                                        <i class="far fa-shopping-cart"></i>
                                        <span class="sr-only">Add This Property to Your Shopping Cart</span>
                                    </a> -->
                    </div>
                </a>
            </GoogleMapInfoWindow>
        </template>
    </PropertySearchMapLoader>
</template>

<script>
import PropertySearchMapLoader from '@vue/components/google-maps/PropertySearchMapLoader.vue';
import PropertySearchMarkers from '@vue/components/rwps/PropertySearchMarkers.vue';
// import GoogleMapLine from '@vue/components/google-maps/GoogleMapLine.vue';
import GoogleMapInfoWindow from '@vue/components/google-maps/GoogleMapInfoWindow.vue';
import {mapState} from 'vuex';

export default {
    props: [
        'mapEl',
        'markers',
        'mapConfig',
        'highlightedProperty',
        'searchType',
    ],
    components: {
        PropertySearchMapLoader,
        PropertySearchMarkers,
        GoogleMapInfoWindow
    },
    data() {
        return {
            lines: [
                {
                    id: '1',
                    path: [
                        { lat: 3, lng: 101 },
                        { lat: 5, lng: 99 }
                    ]
                },
                {
                    id: '2',
                    path: [
                        { lat: 5, lng: 99 },
                        { lat: 6, lng: 97 }
                    ]
                }
            ]
        };
    },
    mounted() {},
    computed: {
        ...mapState('propertySearchStore', [
            'mls_photos'
        ]),
        highlightedPropertyUrl() {
            return this.searchType == 'for-sale'
                ? '/mls-listings/' + this.highlightedProperty.id
                : '/rental-listings/' + this.highlightedProperty.id;
        },
        highlightedPropertyThumbUrl() {
            return this.highlightedProperty.thumbnail_url
                ? this.highlightedProperty.thumbnail_url
                : '/img/default-property-img.jpg';
        }
    },
    methods: {
        // onMapIdle($event){
        //     if(!this.hasInitialBounds){
        //         this.hasInitialBounds = true;
        //         this.$emit('initial-bounds-set', $event.bounds);
        //         // console.log('onBoundsChanged :: initial bounds set ', $event)
        //     } else {
        //         this.$emit('bounds-change', $event.bounds);
        //         // console.log('onBoundsChanged :: bounds changed ', $event)
        //     }
        //     this.$emit('zoom-change', $event.bounds);
        // },

        // onBoundsChanged: _.debounce(function($event){

        // }, 100),

        onDragStart() {
            this.$emit('drag-start');
        },

        onDragEnd($event) {
            this.$emit('drag-end', $event);
        }
    }
};
</script>
